import { render, staticRenderFns } from "./Synthetic.vue?vue&type=template&id=1048ba57&"
import script from "./Synthetic.vue?vue&type=script&lang=js&"
export * from "./Synthetic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports